export default "__VITE_ASSET__Y_rz18kH__"